import { insightsReportedOn } from "@beacon/core/insights/exposure"

/**
 * Whether this build's stage shows Insights: their tab, their page and their setting. The rollout
 * switch the web API reads too (`@beacon/core/insights/exposure`) decides.
 */
export const insightsShown = insightsReportedOn(import.meta.env.VITE_STAGE)
